/** classes */
import { DsLibMainMenuListItem } from './ds-lib-main-menu-list-item.model';
import { DsLibMainMenuSection } from './ds-lib-main-menu-section.model';
/** end classes */

/** interfaces */
import { DsLibMainMenuTabInterface } from '../interfaces/ds-lib-main-menu-tab.interface';
/** end interfaces */

export class DsLibMainMenuTab {
  /**
   * The tab id. Used to select programatically which tab to select.
   */
  id?: number;

  /**
   * The tab title.
   */
  title: string;

  /**
   * The icon to display above the title.
   */
  icon?: string;

  /**
   * List of sections with a title and links.
   */
  sections: DsLibMainMenuSection[] = [];

  /**
   * List of items thatcan be selected from a dropdown select.
   */
  selectItems: DsLibMainMenuListItem[] = [];

  /**
   * The selected item.
   */
  selectedItem: DsLibMainMenuListItem = null;

  /**
   * Whether the select is expanded.
   */
  selectExpanded? = false;

  /**
   * Url that will be given to parent component on click.
   */
  url?: string;

  /**
   * Creates an instance of DsLibMainMenuTab.
   *
   * @param json Given menu tab interface
   */
  constructor(json: DsLibMainMenuTabInterface) {
    this.id = json.id;
    this.title = json.title;
    this.icon = json.icon;
    this.sections = json.sections ? json.sections.map((section) => new DsLibMainMenuSection(section)) : [];
    this.selectItems = json.selectItems
      ? json.selectItems.map((selectItem) => new DsLibMainMenuListItem(selectItem))
      : [];
    this.selectedItem = json.selectedItem ? new DsLibMainMenuListItem(json.selectedItem) : this.selectedItem;
    this.selectExpanded = json.selectExpanded;
    this.url = json.url;
  }
}
